import React, { useCallback, useEffect, useRef, useState } from 'react'
import Spacing from '../componenets/UI/Spacing'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { IoMdArrowForward } from 'react-icons/io'
import { useTranslation } from 'react-i18next'
import axiosClient from '../config/axios-client'
import FutureMineralsRegionDetailsMap from '../componenets/future-minerals-region-details/FutureMineralsRegionDetailsMap'
import FutureMineralsRegionDetailsMapLoading from '../componenets/future-minerals-region-details/FutureMineralsRegionDetailsMapLoading'
import FutureMineralsRegionDetailsParagraph from '../componenets/future-minerals-region-details/FutureMineralsRegionDetailsParagraph'

export default function FutureMineralsRegionDetailsPage() {
  const { lng } = useParams()

  return (
    <div className="app-container px-8 lg:px-0">
      <Spacing />
      <div className="mb-4 flex items-center gap-4">
        <Link
          to={`/${lng}/future-minerals/region`}
          className="bg-primary-600 border-primary-600 hover:text-primary-600 hover:border-secondary-600 hover:bg-muted-300 flex border-2 p-3 text-white"
        >
          <IoMdArrowForward className="h-6 w-6 ltr:rotate-180" />
        </Link>
      </div>
      <FutureMineralsRegionDetailsMap />
      <FutureMineralsRegionDetailsParagraph />
    </div>
  )
}
